import Model, { hasMany } from '@warp-drive/legacy/model';
import type MessageModel from './message.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class MessageableModel extends Model {
  /*************************
   **  Relationships      **
   *************************/

  @hasMany('message', {
    async: false,
    inverse: 'messageable',
    as: 'messageable',
  })
  declare messages: MessageModel[];

  [Type] = 'messageable' as const;
}
